import React, { useEffect, useState } from "react";
import "tailwindcss/tailwind.css";
import time from "../../Assets/image2.png";
import { useDispatch, useSelector } from "react-redux";
import {
  requestBackgroundImage,
  setResetStateLogin,
} from "../../Redux/LoginState/LoginActionCreator";
import { useNavigate } from "react-router-dom";
import ResetForm from "./ResetForm";
import LOCAL_KEYS, { setToLocalStorage } from "../../helpers/Localstorage";
import Loader from "../../components/Loader";

const Reset = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dynamicImages, setDynamicImages] = useState([time]);
  const { loginResponse, isLoading } = useSelector((state) => state.LoginReducer);
  const BackgroundImageReducer = useSelector((state) => state.FileReducer);

  useEffect(() => {
    if (loginResponse !== null) {
      setToLocalStorage(LOCAL_KEYS.ACCESS_TOKEN, loginResponse.access_token);
      setToLocalStorage(LOCAL_KEYS.REFRESH_TOKEN, loginResponse.refresh_token);
      setToLocalStorage(LOCAL_KEYS.USER_DETAILS, loginResponse.userDetails);
      dispatch(setResetStateLogin());
      navigate("/", { replace: true });
    }
  }, [loginResponse]);

  // useEffect(() => {
  //   dispatch(requestBackgroundImage());
  // }, []);

  useEffect(() => {
    if (
      BackgroundImageReducer?.response &&
      BackgroundImageReducer?.response?.blobUrl &&
      !BackgroundImageReducer?.loading
    ) {
      setDynamicImages([BackgroundImageReducer?.response?.blobUrl, time]);
    }
  }, [BackgroundImageReducer]);

  return (
    <div className="flex min-h-screen h-screen w-screen overflow-hidden bg-gray-50">
      {/* Background image section - visible on sm and md screens */}
      <div className="lg:hidden absolute inset-0 w-full h-full">
        <img
          className="w-full h-full object-cover"
          src={time}
          alt="Background"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-black/30 to-transparent opacity-50" />
      </div>

      {/* Right side with background image - only visible on lg screens */}
      <div className="hidden lg:flex lg:w-[70.83%] h-screen relative overflow-hidden">
        <div className="w-full h-full relative">
          <img
            className="absolute inset-0 w-full h-full object-cover"
            src={time}
            alt="Background"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent z-10" />
          <div className="absolute bottom-0 left-0 right-0 p-12 z-20">
            <h2 className="text-4xl font-medium text-gray-400 mb-4 drop-shadow-lg tracking-wide">
              Transforming Ideas into Digital Excellence
            </h2>
          </div>
        </div>
      </div>

      {/* Reset Password form container */}
      <div className="w-full lg:w-[29.17%] flex items-center justify-center h-screen relative z-10">
        <div className="w-full max-w-md px-4 sm:px-8 py-6 flex flex-col items-center justify-center">
          <div className="w-full flex flex-col items-center justify-center">
            <div className="w-full lg:bg-transparent backdrop-blur-md bg-white/10 rounded-2xl p-6 sm:p-8 shadow-2xl border border-white/20 lg:border-none lg:shadow-none lg:rounded-none">
              <ResetForm />
            </div>
          </div>
        </div>
      </div>

      <Loader isLoading={isLoading || BackgroundImageReducer?.loading} />
    </div>
  );
};

export default Reset;
